// Colours, fonts, number formats and shared styles
import { CUR, ccySym } from './budget.js';

export const T = {
  brand: '#808285',
  navy: '#3E3F43',
  navyM: '#5A5C61',
  navyL: '#6B6D73',
  ivory: '#F3F3F4',
  ivoryD: '#E7E7E9',
  ivoryDD: '#D5D6D9',
  white: '#FFFFFF',
  coal: '#1E1E1E',
  slate: '#4E5056',
  mist: '#8A8C91',
  rule: '#D9DADD',
  green: '#1A6E3A',
  greenBg: '#EAF5EE',
  greenBr: '#A3D4B4',
  amber: '#B5600A',
  amberBg: '#FEF3E2',
  amberBr: '#F5C07A',
  red: '#C0392B',
  redBg: '#FDECEA',
  redBr: '#F2A49A',
  blue: '#1455A8',
  blueBg: '#E8F0FE',
  blueBr: '#A8C4F8',
  purple: '#6B3FA0',
  purpBg: '#F3EEF9',
  purpBr: '#C4A8E8'
};
export const MONO = {
  fontFamily: "'DM Mono',monospace"
};
export const fmt = {
  num: (n, d = 0) => n == null ? '—' : Number(n).toLocaleString('en-GB', {
    minimumFractionDigits: d,
    maximumFractionDigits: d
  }),
  // .gbp / .usd keep their old names but show the project's cost and billing currencies
  gbp: n => n == null ? '—' : ccySym(CUR.cost) + fmt.num(n),
  usd: n => n == null ? '—' : ccySym(CUR.bill) + fmt.num(n),
  pct: (n, d = 1) => n == null ? '—' : (n * 100).toFixed(d) + '%',
  ccy: (n, c) => n == null ? '—' : ccySym(c) + fmt.num(n),
  date: d => d ? new Date(d).toLocaleDateString('en-GB', {
    day: '2-digit',
    month: 'short',
    year: 'numeric'
  }) : new Date().toLocaleDateString('en-GB', {
    day: '2-digit',
    month: 'short',
    year: 'numeric'
  })
};
